export default (dateStr: string | null): string => {
  if (!dateStr) {
    return 'Invalid date';
  }

  let year: number;
  let month: number;
  let day: number;

  if (dateStr.includes('T')) {
    dateStr = dateStr.split('T')[0];
  }

  if (dateStr.includes('/')) {
    const parts = dateStr.split('/');
    if (parts.length !== 3) return 'Invalid date format';
    
    [month, day, year] = parts.map(Number);
    
    if (isNaN(month) || isNaN(day) || isNaN(year) || month < 1 || month > 12 || day < 1 || day > 31) {
      return 'Invalid date';
    }

  } else if (dateStr.includes('-')) {
    const parts = dateStr.split('-');
    if (parts.length !== 3) return 'Invalid date format';
    
    [year, month, day] = parts.map(Number);
    
    if (isNaN(month) || isNaN(day) || isNaN(year) || month < 1 || month > 12 || day < 1 || day > 31) {
      return 'Invalid date';
    }

  } else {
    return 'Invalid date format';
  }

  const date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return 'Invalid date';
  }

  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };

  return date.toLocaleDateString('en-US', options);
};
